module.exports = __webpack_public_path__ + "img/3.55057cf8.gif";